module.exports = __webpack_public_path__ + "static/media/instagram.56aaa593.png";